<template>
  <div>
    <div v-if="ready">
      <slot name="top"/>
      <q-btn
        outline
        color="negative"
        label="delete record"
        @click="handleDeleteRecord"
        icon="delete"
        v-if="!accountModal && this.form.id"
      />
      <div class="block q-pa-sm" v-if="!accountModal"></div>
      <div class="block full-width" v-if="!accountModal">
        <div class="row justify-between">
          <div class="col-md-10">
            <h5 class="text-grey-6 uppercase no-margin q-headline q-pb-sm">User Info</h5>
          </div>
        </div>
      </div>
      <div class="mdi-card full-width q-pa-md">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
            <q-field
              orientation="vertical"
              label="Email / Username"
              class="q-pa-md"
              inset="full"
              :icon="errors.has('Email', validatorFormName) ? 'star_border' : 'star'"
              :icon-color="errors.has('Email', validatorFormName) ? 'negative' : 'blue-5'"
              :class="{'is-required': errors.has('Email', validatorFormName)}"
              :error="errors.has('Email', validatorFormName)"
              :error-label="errors.first('Email', validatorFormName)"
              :helper="'Username is: ' + oldUsername + ' - if this does not match the email.  It will after save.'"
            >
              <q-input
                v-validate="'required|email|uniqueusername'"
                data-vv-name="Email"
                v-model="form.email"
                type="email"
                name="email"
                class="no-shadow"
                hide-underline
                inverted-light
                :color="errors.has('Email') ? 'negative' : inputBgColor"
                :validator-form-name="validatorFormName"
                :data-vv-scope="validatorFormName"
              />
            </q-field>
            <!-- <q-field
                  orientation="vertical"
                  label="Username"
                  class="q-pa-md"
                  inset="full"
                  :icon="errors.has('Username', validatorFormName) ? 'star_border' : 'star'"
                  :icon-color="errors.has('Username', validatorFormName) ? 'negative' : 'blue-5'"
                  :class="{'is-required': errors.has('Username', validatorFormName)}"
                  :error="errors.has('Username', validatorFormName)"
                  :error-label="errors.first('Username', validatorFormName)"
                  :helper="errors.first('Username', validatorFormName)"
                >
                <q-input
                v-validate="'required'"
                data-vv-name="Username"
                v-model="form.userName"
                type="text"
                name="userName"
                class="no-shadow"
                hide-underline
                inverted-light
                :color="errors.has('Username', validatorFormName) ? 'negative' : inputBgColor"
                :validator-form-name="validatorFormName"
                :data-vv-scope="validatorFormName"
                />
            </q-field>-->
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
            <q-field
              orientation="vertical"
              label="Role"
              class="q-pa-md"
              inset="full"
              :icon="errors.has('Role', validatorFormName) ? 'star_border' : 'star'"
              :icon-color="errors.has('Role', validatorFormName) ? 'negative' : 'blue-5'"
              :class="{'is-required': errors.has('Role', validatorFormName)}"
              :error="errors.has('Role', validatorFormName)"
              :error-label="errors.first('Role', validatorFormName)"
            >
              <q-select
                v-validate="'required'"
                data-vv-name="Role"
                v-model="form.roleId"
                name="roleId"
                class="no-shadow"
                hide-underline
                inverted-light
                :options="roleSelections"
                :color="errors.has('Role') ? 'negative' : inputBgColor"
                :validator-form-name="validatorFormName"
                :data-vv-scope="validatorFormName"
              />
            </q-field>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
            <q-field
              orientation="vertical"
              label="Password"
              class="q-pa-md"
              inset="full"
              icon="edit"
              :icon-color="errors.has('Password', validatorFormName) ? 'negative' : inputBgColor"
              :class="{'is-required': errors.has('Password', validatorFormName)}"
              :error="errors.has('Username', validatorFormName)"
              :error-label="errors.first('Password', validatorFormName)"
              :helper="errors.first('Password', validatorFormName)"
            >
              <q-input
                v-validate="'min:6'"
                data-vv-name="Password"
                v-model="form.password"
                type="password"
                name="password"
                class="no-shadow"
                hide-underline
                inverted-light
                :color="errors.has('Password', validatorFormName) ? 'negative' : inputBgColor"
                :validator-form-name="validatorFormName"
                :data-vv-scope="validatorFormName"
                ref="password"
              />
            </q-field>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
            <q-field
              orientation="vertical"
              label="Password Confirmation"
              class="q-pa-md"
              inset="full"
              icon="edit"
              :icon-color="errors.has('Password Confirmation', validatorFormName) ? 'negative' : inputBgColor"
              :class="{'is-required': errors.has('Password Confirmation', validatorFormName)}"
              :error="errors.has('Password Confirmation', validatorFormName)"
              :error-label="errors.first('Password Confirmation', validatorFormName)"
            >
              <q-input
                v-validate="form.password ? 'required|confirmed:password' : ''"
                data-vv-name="Password Confirmation"
                v-model="passwordConfirmation"
                type="password"
                name="passwordConfirmation"
                class="no-shadow"
                hide-underline
                inverted-light
                :color="errors.has('Password Confirmation') ? 'negative' : inputBgColor"
                :validator-form-name="validatorFormName"
                :data-vv-scope="validatorFormName"
                data-vv-as="password"
              />
            </q-field>
          </div>
        </div>
        <div class="row" v-if="!accountModal">
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
            <q-field
              orientation="vertical"
              label="Lock User Out / Prevent Login"
              class="q-pa-md"
              inset="full"
              icon="edit"
              :icon-color="inputBgColor"
            >
              <q-checkbox v-model="lockout" name="Lockout"/>
            </q-field>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
            <q-field
              orientation="vertical"
              label="Failed Logins"
              class="q-pa-md"
              inset="full"
            >{{ form.accessFailedCount }}</q-field>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
            <q-field
              orientation="vertical"
              label="Last Logged In"
              class="q-pa-md"
              inset="full"
            >{{ form.lastLoginDate }}</q-field>
          </div>
        </div>
      </div>
      <div v-if="editingDisabled">
        <q-alert
          v-if="editingDisabled"
          type="warning"
          icon="warning"
          class="q-mb-md"
        >This record has been deleted / archived. You may not make edits to this record until it has been restore.</q-alert>
        <q-btn
          color="negative"
          @click="apiRestoreRecord"
          class="full-width"
          push
          size="lg"
          :disabled="false"
        >Restore</q-btn>
      </div>
      <div v-else>
        <q-btn
          color="primary"
          @click="submit"
          class="full-width"
          push
          size="lg"
          :disabled="false"
        >Save</q-btn>
      </div>
      <div name="goback" v-if="!accountModal">
        <q-btn flat to="/user/list" color="negative" full class="q-mt-lg">Cancel</q-btn>
      </div>
    </div>
    <q-inner-loading v-if="loading"></q-inner-loading>
  </div>
</template>

<script>
// import { Validator } from 'vee-validate'

export default {
  inject: ['$validator'],
  name: 'UserEdit',
  props: {
    accountModal: false,
    user: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      ready: false,
      loading: true,
      editingDisabled: false,
      validatorFormName: 'users',
      inputBgColor: 'blue-grey-1',
      errorBg: 'negative',
      passwordConfirmation: null,
      lockout: false,
      roles: null,
      oldUsername: null,
      form: {
        accessFailedCount: 0,
        email: null,
        id: 0,
        lastLoginDate: null,
        lockoutEnabled: false,
        lockoutEnd: null,
        password: null,
        passwordNew: false,
        phoneNumber: null,
        roleId: null,
        userName: null
      }
    }
  },
  computed: {
    roleSelections () {
      if (this.roles && this.roles.length > 0) {
        return this.roles.map(value => {
          let i = {}
          if (value.name) {
            i.label = value.name
          }
          if (value.id) {
            i.value = value.id
          }
          return i
        })
      } else {
        return [{ value: 1, label: 'Admin' }, { value: 2, label: 'Customer' }, { value: 3, label: 'Super Admin' }]
      }
    }
  },
  methods: {
    async getUser () {
      if (this.user) {
        this.form.accessFailedCount = this.user.accessFailedCount
        this.form.email = this.user.email
        this.form.id = this.user.id
        this.form.lastLoginDate = this.user.lastLoginDate
        this.form.lockoutEnabled = this.user.lockoutEnabled
        this.form.lockoutEnd = this.user.lockoutEnd
        this.form.phoneNumber = this.user.phoneNumber
        this.form.roleId = this.user.roleId
        this.form.userName = this.user.email
        this.oldUsername = this.user.userName
        this.ready = true
        this.loading = false
      } else {
        if (this.$route.params.id) {
          try {
            const { data } = await this.$axios.get('/api/aspnetuser/' + this.$route.params.id)
            if (data) {
              // this.user = data
              this.form.accessFailedCount = data.accessFailedCount
              this.form.email = data.email
              this.form.id = data.id
              this.form.lastLoginDate = data.lastLoginDate
              this.form.lockoutEnabled = data.lockoutEnabled
              this.form.lockoutEnd = data.lockoutEnd
              this.form.phoneNumber = data.phoneNumber
              this.form.roleId = data.roleId
              this.form.userName = data.email
              this.oldUsername = data.userName
              if (data.roles) {
                this.roles = data.roles
              }
              if (this.form.lockoutEnabled && this.form.lockoutEnd) {
                this.lockout = true
              }
              this.ready = true
              this.loading = false
            } else {
              this.$q.notify({
                message: 'Error fetching user'
              })
              this.ready = true
              this.loading = false
            }
          } catch (e) {
            this.$q.notify({
              message: 'Error fetching user'
            })
            this.ready = true
            this.loading = false
          }
        } else {
          // New User!
          this.ready = true
          this.loading = false
        }
      }
    },
    async submit () {
      // console.log('submit')
      // console.log(this.$validator)
      const result = await this.$validator.validate(this.validatorFormName + '.*')
      if (!result) {
        this.$q.notify({
          message: 'Please complete all required fields',
          type: 'negative'
        })
        return
      }
      if (this.form.password && this.passwordConfirmation && this.form.password === this.passwordConfirmation) {
        this.form.passwordNew = true
      }
      if (!this.form.id) {
        // POST
        try {
          const { data } = await this.$axios.post(`/api/aspnetuser/0`, this.form)
          if (data) {
            if (data.success) {
              this.$q.notify({
                message: 'User created',
                type: 'positive'
              })
            } else {
              this.$q.notify({
                message: 'Error creating user: ' + data.messag
              })
            }
          } else {
            this.$q.notify({
              message: 'Error creating user'
            })
          }
        } catch (e) {
          this.$q.notify({
            message: 'Error creating user'
          })
        }
      } else {
        // PUT
        try {
          const { data } = await this.$axios.post(`/api/aspnetuser/${this.form.id}`, this.form)
          if (data) {
            // this.$set(this.timecardDays, day, extend(true, {}, data))
            // console.log('PUT Addition Saved: ', data)
            if (data.success) {
              this.$q.notify({
                message: 'User saved',
                type: 'positive'
              })
            } else {
              this.$q.notify({
                message: 'Error saving user: ' + data.message
              })
            }
          } else {
            this.$q.notify({
              message: 'Error saving user'
            })
          }
        } catch (e) {
          this.$q.notify({
            message: 'Error saving user'
          })
        }
      }
    },
    async handleDeleteRecord () {
      let r = confirm('Are you sure you wish to delete this user?')
      if (r) {
        if (this.form.id) {
          try {
            const { data } = await this.$axios.delete(`/api/aspnetuser/${this.form.id}`)
            if (data && !data.error) {
              this.$q.notify({
                message: 'User deleted',
                type: 'positive'
              })
            } else {
              this.$q.notify({
                message: 'Error deleting user'
              })
            }
          } catch (e) {
            this.$q.notify({
              message: 'Error deleting user'
            })
          }
        } else {
          this.$q.notify({
            message: 'User does not exist or has not been created'
          })
        }
      }
    },
    async isUnique (username) {
      let url = '/api/aspnetuser/emailexists'
      if (this.form && this.form.id) {
        url = `/api/aspnetuser/emailexists/${this.form.id}`
      }
      const { data } = await this.$axios.get(url, {
        // id: this.modelId || undefined,
        params: { email: username }
      })
      if (data) {
        return {
          valid: false,
          data: {
            message: ` Email / Username is already taken.`
          }
        }
      }
      return true
    }
  },
  // mounted () {
  //   this.$validator.extend('uniqueusername', {
  //     validate: this.isUnique,
  //     getMessage: (field, params, data) => data.message
  //   })
  // },
  created () {
    this.$validator.extend('uniqueusername', {
      validate: this.isUnique,
      getMessage: (field, params, data) => data.message
    })
    this.getUser()
  },
  watch: {
    lockout (val) {
      if (val) {
        this.form.lockoutEnabled = true
        this.form.lockoutEnd = '0100-01-01T00:00:00'
      } else {
        this.form.lockoutEnabled = false
        this.form.lockoutEnd = null
      }
    },
    'form.email' (val) {
      if (val) {
        this.form.userName = this.form.email
      }
    }
  }
}
</script>

<style>
</style>
